module.exports = __webpack_public_path__ + "media/images/icons/country_flags/sg-8b629e7bf137abf1643b88d0e02d9d3a.svg";